import { Injectable } from '@angular/core';

/**
 * Holds the per-session CSRF token in memory (same posture as the rest of the
 * auth state). It is captured from any backend response carrying
 * `data.csrf_token` (login, /auth/me boot probe) and attached by the
 * RegulatedInterceptor as the X-CSRF-Token header on state-changing requests.
 */
@Injectable({
  providedIn: 'root'
})
export class CsrfTokenService {
  private token: string | null = null;

  get(): string | null {
    return this.token;
  }

  set(token: string): void {
    this.token = token;
  }

  clear(): void {
    this.token = null;
  }
}
